import React from 'react';
import Chat from './Chat';


const ChatContainer: React.FC<unknown> = () => {
  return <Chat />;
};

export default ChatContainer;
